module.exports = __webpack_public_path__ + "img/star2.247fe86a.gif";